export { default as Img200 } from './processed/200/scales-blue-dark-tile.jpg';
export { default as Img400 } from './processed/400/scales-blue-dark-tile.jpg';
export { default as Imgthumb } from './processed/thumb/scales-blue-dark-tile.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/scales-blue-dark-tile.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/scales-blue-dark-tile.jpg';
export const ImgData = { width: 300, height: 300, ratio: 1, orientation: 'portrait' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      67,
      125,
      188
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      28,
      52,
      78
    ],
    "_population": 4,
    "_hsl": [
      0.5866666666666667,
      0.47169811320754723,
      0.20784313725490197
    ]
  },
  "DarkMuted": {
    "_rgb": [
      46,
      63,
      83
    ],
    "_population": 55,
    "_hsl": [
      0.5900900900900901,
      0.2868217054263566,
      0.2529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/scales-blue-dark-tile.js